import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import {
  buildNineSegmentsAnswersArrayData,
  type NineSegmentsAnswerData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand, useSurveyQueryQuestions } from '~/hooks/useSurveyQuery'
import { exists } from '~/utils'

import { nineSegmentSortFunctionAtom, tabulationQueryDataAtom } from '../atoms'

import { useGetBrandNineSegmentIndex } from './useGetBrandNineSegmentIndex'
import { useGetNineSegmentsData } from './useGetNineSegmentsData'

export const useNineSegmentsAnswersArrayData = (
  brand: Brand,
): NineSegmentsAnswerData[][] => {
  const questions = useSurveyQueryQuestions()
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const getNineSegmentsData = useGetNineSegmentsData(brand)
  const sort = useAtomValue(nineSegmentSortFunctionAtom)
  const getBrandNineSegmentIndex = useGetBrandNineSegmentIndex()

  return React.useMemo(
    () =>
      buildNineSegmentsAnswersArrayData({
        brand,
        countAnswers:
          tabulationQueryData?.question?.results
            ?.flatMap(R.identity())
            .filter(exists) ?? [],
        getBrandNineSegmentIndex,
        getNineSegmentsData,
        questions,
        sort,
      }),
    [
      brand,
      getNineSegmentsData,
      getBrandNineSegmentIndex,
      questions,
      sort,
      tabulationQueryData?.question?.results,
    ],
  )
}
